<template>
  <!--页脚-->
  <el-row class="index_bottom">
    <div class="index_bottom_bac">
      <div id="JYL_footer" data-key="nemojoy"></div>
    </div>
  </el-row>
</template>

<script>
import vv from '@/components/varVariable'

export default {
  name: 'Bottom',
  data() {
    return {
      bottom_data: {}
    }
  },
  computed: {
    filePath() {
      return vv.fileHttp
    }
  },
  mounted() {
    if (!document.querySelector('script[src="https://static.nemojoy.com/libs/footer/footer.js"]')) {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://static.nemojoy.com/libs/footer/footer.js'
      document.body.appendChild(script)
    }
  }
}
</script>

<style lang="scss">
.index_bottom{
  overflow: hidden;

  .index_bottom_bac {
    background: #333333;
  }
}
</style>
